'use strict';

import { flow, observable, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import api from '../lib/Api';

/**
 * Store for the list of instructor names for the course search autofill suggestions section.
 */
class InstructorsStore {

    state;

    constructor() {
        makeObservable(this, {
            state: observable
        });

        this.instructorsList = [];
        this.exceptionUtils = appStore.getExceptionUtils();
    }

    loadInstructors = flow(function* () {
        this.state = States.pending;
        // Stop if data has already been loaded.
        if (this.instructorsList.length != 0) {
            this.state = States.done;
            return;
        }

        if (appStore.isDebug()) {
            console.log("InstructorsStore: Starting data load.");
        }

        try {
            this.instructorsList = yield api.getInstructors();

            if (appStore.isDebug()) {
                console.log("InstructorsStore: Data load complete.");
            }

            this.state = States.done;
        } catch (error) {
            this.exceptionUtils.handleException(error);
            this.state = States.error;
        }
    });
}

export default new InstructorsStore();